// extracted by mini-css-extract-plugin
export var fadeIn = "_gt-1";
export var modalContent = "_gt-3";
export var overlay = "_gt-0";
export var popoverContent = "_gt-2";
export var results = "_gt-5";
export var searchInputWrapper = "_gt-4";